module.exports = __webpack_public_path__ + "img/guide00.4369688a.png";